import Head from "next/head";
import { END } from "redux-saga";
import { useSelector } from "react-redux";

import OurSpacesList from "../../src/ourSpace/OurSpacesList";

import { wrapper } from "../../src/config/Store";
import { getAllCMS } from "../../src/redux/cms/CMSActions";
import constants from "../../src/utils/Constants";
import Routes from "../../src/routes/Routes";
import { availabilityWebPageSchema } from "../../GO-Bermondsey_Schema";

const { CMS_TYPES, CMS_PAGES } = constants;

const OurSpaces = () => {
  const mPageDetails = useSelector(({ cms }) => {
    const boardKey = JSON.stringify({
      type: CMS_TYPES.PAGE_META,
      page_name: CMS_PAGES.OUR_SPACE,
    });

    const boards = cms.boards;
    const mPageDetailsId = boards[boardKey]?.list?.[0];

    return cms.cmsMap[mPageDetailsId] || {};
  });

  return (
    <>
      <Head>
        <title>{mPageDetails.name}</title>
        <meta name="description" content={mPageDetails.description} />
        <meta itemProp="name" content="" />
        <meta itemProp="description" content="" />
        <meta itemProp="image" content="" />
        <link
          rel="canonical"
          href={`${Routes?.domain}${Routes?.availability}`}
        />

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: availabilityWebPageSchema,
          }}
        />
      </Head>

      <OurSpacesList />
    </>
  );
};

export const getServerSideProps = wrapper.getServerSideProps(
  (store) => async (context) => {
    const cmsState = store.getState().cms;

    const pageDetailsParams = {
      type: CMS_TYPES.PAGE_META,
      page_name: CMS_PAGES.OUR_SPACE,
    };
    const pageDetailsBoard = cmsState.boards[JSON.stringify(pageDetailsParams)];
    if (!pageDetailsBoard) {
      store.dispatch(getAllCMS(pageDetailsParams));
    }

    const ourSpacesParams = { type: CMS_TYPES.OUR_SPACE };
    const ourSpacesBoard = cmsState.boards[JSON.stringify(ourSpacesParams)];
    if (!ourSpacesBoard) {
      store.dispatch(getAllCMS(ourSpacesParams));
    }

    const availabilityPageFoldsParams = { type: CMS_TYPES.AVAILABILITY_PAGE };
    const availabilityPageFoldsBoard =
      cmsState.boards[JSON.stringify(availabilityPageFoldsParams)];
    if (!availabilityPageFoldsBoard) {
      store.dispatch(getAllCMS(availabilityPageFoldsParams));
    }

    if (!pageDetailsBoard || !ourSpacesBoard) {
      store.dispatch(END);
    }

    await store.sagaTask.toPromise();
  }
);

export default OurSpaces;
